module.exports = __webpack_public_path__ + "img/img (8).655e252b.jpg";